import { UploadFile, notification } from 'antd';

export const CERTIFIER_SIGNATURE_ACCEPT = 'image/png, image/jpeg, image/jpg';

const CERTIFIER_SIGNATURE_EXTENSIONS = ['png', 'jpg', 'jpeg'] as const;

export const validateCertifierSignatureFile = async (file: UploadFile) => {
  const extension = file.name.split('.').pop()?.toLowerCase();
  const isValid = CERTIFIER_SIGNATURE_EXTENSIONS.includes(
    extension as (typeof CERTIFIER_SIGNATURE_EXTENSIONS)[number]
  );

  if (!isValid) {
    notification.error({
      message: 'Formato inválido',
      description: 'A assinatura digital deve ser PNG, JPG ou JPEG.',
      duration: 3
    });
  }

  return isValid;
};
